import { __assign, __rest } from "tslib";
import React from "react";
import defaultLocale from "../locale/default";
var defaultContextValue = {
  locale: defaultLocale
};
var ConfigContext = React.createContext(defaultContextValue);
export function ConfigProvider(_a) {
  var children = _a.children,
      configs = __rest(_a, ["children"]);

  var configsCache = React.useRef(defaultContextValue);
  var memoConfigs = React.useMemo(function () {
    var newConfigs = __assign(__assign({}, configsCache.current), configs);

    for (var key in newConfigs) {
      if (newConfigs[key] !== configsCache.current[key]) {
        configsCache.current = newConfigs;
        return newConfigs;
      }
    }

    return configsCache.current;
  }, [configs]);
  return React.createElement(ConfigContext.Provider, {
    value: memoConfigs
  }, children);
}
export function withConfigs(Component) {
  var MemoComponent = React.memo(Component);
  return function WrappedComponent(props) {
    var configs = React.useContext(ConfigContext);
    return React.createElement(MemoComponent, __assign({}, props, {
      configs: configs
    }));
  };
}
export function useConfigs() {
  var configs = React.useContext(ConfigContext);
  return configs;
}